<template>
  <div>
    <h1 class="display-1 primary--text">
      {{ $t('message.indicator_list_title') }}
    </h1>
    <v-data-table
      :headers="headers"
      :items="indicatorsList"
      class="elevation-1"
      :pagination.sync="pagination"
      item-key="date"
    >
      <template v-slot:items="row">
        <tr @click="onSelect(row.item)">
          <td v-if="user.isAdmin">
            {{ users[row.item.userId] | fullName }}
          </td>
          <td>{{ row.item.date | formatDate }}</td>
          <td>
            <v-icon
              v-if="!row.item.isDraft"
              color="success"
            >
              fa-check
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              fa-times
            </v-icon>
          </td>
          <td>
            <v-icon
              v-if="!isEmpty(row.item.approvedOn)"
              color="success"
            >
              fa-check
            </v-icon>
            <v-icon
              v-else-if="!row.item.isDraft && user.isAdmin"
              color="error"
            >
              fa-eye
            </v-icon>
            <v-icon
              v-else-if="!row.item.isDraft && !user.isAdmin"
              color="error"
            >
              fa-hourglass-half
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-btn
      v-if="!user.isAdmin"
      color="secondary"
      fab
      fixed
      bottom
      right
      dark
      class="mb-4"
      @click="createNewIndicators"
    >
      <v-icon dark>
        add
      </v-icon>
    </v-btn>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import isEmpty from 'lodash/isEmpty'
import last from 'lodash/last'

export default {
  name: 'IndicatorsList',
  data: (vm) => {
    let headers = [
      { text: vm.$t('message.user'), value: 'userId' },
      { text: vm.$t('message.date'), value: 'date' },
      { text: vm.$t('message.ready_for_approval'), value: 'isDraft' },
      { text: vm.$t('message.approved'), value: 'approvedOn' },
    ].filter((e) => vm.$store.state.user.isAdmin || e.value != 'userId')
    return {
      headers: headers,
      dialog: false,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: -1, // -1 for All",
        sortBy: 'date',
      },
    }
  },
  computed: {
    ...mapState({
      indicatorsList: (state) => state.indicatorsList,
      user: (state) => state.user,
      users: (state) => {
        let usersMap = {}
        state.users.forEach((u) => {
          usersMap[u._id] = u
        })

        return usersMap
      },
    }),
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
      case 'onIndicatorsCreated':
        this.$router.push({
          name: 'indicators',
          params: { indicatorId: mutation.payload._id },
        })
        break
      }
    })

    if (this.user.isAdmin && Object.keys(this.users).length == 0) {
      this.$store.dispatch('getUsers')
    }
    this.$store.dispatch('getIndicatorsList')
  },
  methods: {
    save: function () {
      this.dialog = false
    },
    onSelect(item) {
      const indicatorId = item._id
      this.$router.push({ name: 'indicators', params: { indicatorId } })
    },
    draftIcon(value) {
      return value ? 'fa-minus' : 'fa-check'
    },
    isEmpty: isEmpty,
    createNewIndicators() {
      if (
        isEmpty(this.indicatorsList) ||
        !isEmpty(last(this.indicatorsList).approvedOn)
      ) {
        this.$store.dispatch('createIndicators', {
          date: new Date().toString(),
          isDraft: true,
        })
      } else {
        this.$store.commit(
          'showSnackbarWarning',
          this.$t('message.previous_indicators_not_approved_yet')
        )
      }
    },
  },
}
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
